import React from "react";

import Dropdown from "components/Dropdown";

import classes from "./styles.module.scss";

const SortDropdown = ({ open, close, setSortOption, sortOption }) => (
    <Dropdown
        open={open}
        style={{ top: "unset" }}
        className={classes.sortDropdown}
        options={[
            {
                label: "Newest",
                value: "newest",
                onClick: () => {
                    setSortOption({ value: "newest", label: "Newest" });
                    close();
                },
            },
            {
                label: "Oldest",
                value: "oldest",
                onClick: () => {
                    setSortOption({ value: "oldest", label: "Oldest" });
                    close();
                },
            },
        ]}
    />
);

export default SortDropdown;
